import { View } from "react-native"

const EmptyView = () => {
  return <View style={{ height: 0, width: 0 }} />
}

export default EmptyView
